import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import {
  BlueBirdTheme,
  Dropdown,
  Form,
  Radio,
  RadioGroup,
  Typography,
} from "@kitbird/core";
import { FormContainer } from "../../../../../components/Form/Form.style";
import useDepartment from "../../useDepartment";

interface DepartmentFormProps {
  defaultValue: unknown;
  onClose: () => void;
  useCustomHook: ReturnType<typeof useDepartment>;
}

const { danger } = BlueBirdTheme.colors;

const DepartmentForm = ({ defaultValue, useCustomHook }: DepartmentFormProps) => {
  const {
    methods,
    masterDepartmentCostList,
    handlePost,
  } = useCustomHook;

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  return (
    <form onSubmit={handleSubmit(handlePost)}>
      <FormContainer>
        <div>
          <RadioGroup
            onChange={(e) => setValue("code_type", e.target.value, { shouldValidate: true })}
            title="Tipe user"
            value={getValues("code_type")}
          >
            <div
              className="radio-group"
            >
              <Radio
                id="code_type_O"
                label="HO"
                value="O"
                name="code_type"
              />
              <Radio
                id="code_type_P"
                label="Pool"
                value="P"
                name="code_type"
              />
              <Radio
                id="code_type_H"
                label="Pangkalan"
                value="H"
                name="code_type"
              />
            </div>
          </RadioGroup>
          <Typography level={7} color={danger[500]}>{errors.code_type?.message}</Typography>
        </div>
        <Controller
          control={control}
          name="department"
          render={({ field, fieldState: { error } }) => (
            <Form
              {...field}
              label="Departemen"
              error={error && { message: error.message || "" }}
            />
          )}
        />
        <Controller
          control={control}
          name="department_desc"
          render={({ field, fieldState: { error } }) => (
            <Form
              {...field}
              label="Deskripsi"
              error={error && { message: error.message || "" }}
            />
          )}
        />
        <Controller
          control={control}
          name="department_cost"
          render={({
            field: {
              name, onChange, ref, value,
            },
            fieldState: { error },
          }) => (
            <Dropdown
              name={name}
              id="department_cost"
              label="Departemen cost"
              options={masterDepartmentCostList?.map((item) => (
                { label: item.code_dep, value: item.code_dep }
              )) || []}
              ref={ref}
              value={value}
              onSelected={(item) => onChange(item.value)}
              error={error && { message: error.message || "" }}
            />
          )}
        />
      </FormContainer>
    </form >
  );
};

export default DepartmentForm;
